module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-14.cb976e04.png";